<template>
  <div id="signIn" v-if="!loggedIn">
    <v-btn flat @click="signIn" target="_blank">
      <v-icon left large>account_circle</v-icon>
      <span class="mr-2">Sign in</span>
    </v-btn>
  </div>

  <div id="signOut" v-else>
    <v-btn flat @click="signOut" target="_blank">
      <v-avatar size="32" class="mr-3">
        <v-img :src="profileImage"></v-img>
      </v-avatar>
      <span class="mr-2">Sign out</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: "ToolbarAccount",
  computed: {
    loggedIn() {
      return this.$store.state.auth.signedIn;
    },
    profileImage() {
      return this.$store.state.auth.profile.image;
    }
  },
  methods: {
    signIn() {
      console.log("sign in used");
      this.$store.dispatch("signIn");
    },
    signOut() {
      this.$store.dispatch("signOut");
    }
  }
};
</script>